module.exports = __webpack_public_path__ + "img/23.ec286c40.png";